import InformationBox from 'App/components/InformationBox'
import { ExpandableListItem } from '@trr/internaltypes'
import { ExpandableList } from '@trr/html-mapper'
import FAQSchema from './FAQSchema'

export interface FAQBlockProps {
  content: {
    heading: string
    preamble?: string
    link?: {
      text: string
      url: string
    }
    listHeading: string
    listItems: { properties: ExpandableListItem }[]
    color?: string
    useColor?: boolean
  }
}

const FAQBlock = ({
  content: { heading, preamble, link, listHeading, listItems, color, useColor },
}: FAQBlockProps) => {
  return (
    <>
      <FAQSchema listItems={listItems} />
      <InformationBox
        heading={heading}
        body={preamble}
        link={link}
        color={color}
        useColor={useColor}
      >
        <ExpandableList
          mediaUrl={window.APP_CONFIGURATION.COMMON.MEDIA_URL}
          heading={listHeading}
          listItems={listItems}
          variant="single"
        />
      </InformationBox>
    </>
  )
}

export default FAQBlock
